// © Microsoft Corporation. All rights reserved.

import Popover from "../../../common/popover/Popover";
import React from "react";
import { SocialProps } from "../../../Social.props";
import { String } from "typescript-string-operations";
import { abbreviateNumber } from "@msnews/core";
import { classNames } from "@microsoft/fast-web-utilities";

export interface PublisherProfileCardStatsProps extends SocialProps {
    followersCount: number;
}

export interface PublisherProfileCardStatsState {
    followersDefinitionPopoverVisible: boolean;
}

export default class PublisherProfileCardStats extends React.Component<PublisherProfileCardStatsProps, PublisherProfileCardStatsState> {
    followersTriggerRef: React.RefObject<HTMLDivElement>;

    constructor(props) {
        super(props);
        this.state = {
            followersDefinitionPopoverVisible: false
        };
        this.followersTriggerRef = React.createRef();
    }

    render() {
        return this.renderDefault();
    }

    renderDefault() {
        const { followersCount, t, responsiveClass, managedClasses } = this.props;

        return (
            <div className={classNames(
                managedClasses.publisherProfileCardStatsContainer,
                responsiveClass
            )}>
                <div
                    onMouseEnter={(e) => this.setState({followersDefinitionPopoverVisible: true})}
                    onMouseLeave={(e) => this.setState({followersDefinitionPopoverVisible: false})}
                    className="cwt-stat" ref={this.followersTriggerRef} aria-label={followersCount > 1 ? String.Format(t.AriaLabelFollowers, followersCount) : String.Format(t.AriaLabelFollower, followersCount)}
                >
                    <span className="cwt-stat-counter" aria-hidden="true"> {this.abbreviate(followersCount) || "-"} {t.ProfileFollowersLbl} </span>
                </div>
                {  this.state.followersDefinitionPopoverVisible && <Popover
                    {...{
                        visible: this.state.followersDefinitionPopoverVisible,
                        triggerRef: this.followersTriggerRef,
                        onHide: () => this.setState({followersDefinitionPopoverVisible: false}),
                        className: managedClasses.followersDefinitionPopoverContainer,
                        managedClasses: managedClasses,
                        isHover: true,
                        hoverDelay: 600
                    }}>
                    { this.renderPopoverContext(this.getFollowersDefinitionText()) }
                </Popover>
                }
            </div>
        );
    }

    getLikesDefinitionText() {
        return this.props.t.PublisherProfilePageLikesDescription;
    }

    getFollowersDefinitionText() {
        return this.props.t.PublisherProfilePageFollowersDescription;
    }

    abbreviate(value) {
        return abbreviateNumber(value);
    }

    renderPopoverContext(definition: string) {
        return (
            <div className={this.props.managedClasses.infoPopover}>
                <p>{ definition }</p>
            </div>
        );
    }
}
